import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import ImageNotSupportedIcon from '@mui/icons-material/ImageNotSupported';

const EmptyState = ({ type = 'default', message, subtitle }) => {
  const getConfig = () => {
    switch (type) {
      case 'no-results':
        return {
          icon: <SearchOffIcon sx={{ fontSize: 80, color: 'text.disabled' }} />,
          title: message || 'No Results Found',
          subtitle: subtitle || 'Try adjusting your filters or search terms',
        };
      case 'no-avatars':
        return {
          icon: <ImageNotSupportedIcon sx={{ fontSize: 80, color: 'text.disabled' }} />,
          title: message || 'No Avatars Available',
          subtitle: subtitle || 'Please check back later',
        };
      default:
        return {
          icon: <SentimentDissatisfiedIcon sx={{ fontSize: 80, color: 'text.disabled' }} />,
          title: message || 'Nothing to Show',
          subtitle: subtitle || 'No data available at the moment',
        };
    }
  };

  const config = getConfig();

  return (
    <Paper
      elevation={0}
      sx={{
        p: 6,
        textAlign: 'center',
        backgroundColor: 'grey.50',
        borderRadius: 2,
      }}
    >
      <Box sx={{ mb: 2 }}>{config.icon}</Box>
      <Typography variant="h6" fontWeight={600} gutterBottom>
        {config.title}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {config.subtitle}
      </Typography>
    </Paper>
  );
};

export default EmptyState;
